import { getIdFromLocalStorage } from '../helpers/base';

export const appSubtitle = 'Perseus Biomics Platform';

export const BASE_BACKEND_URL = process.env.REACT_APP_BASE_BACKEND_URL;

export const METRICS_ITEMS = ['Classification', 'Segmentation', 'QC'];

export const TCGA_GTAC = 'TCGA-GTAC';
export const TCGA = 'TCGA';
export const GTAC = 'GTAC';
export const LABELLING_ITEMS = [TCGA, GTAC, TCGA_GTAC];
export const SAMPLE_TYPE_ITEMS = ['Fecal', 'Ecoli', 'Mock'];
export const PIPELINES_VALUES = [
  'segment_classify',
  'segment_classify_d6300',
  'segment_classify_d6322',
  'segment_classify_d6331',
  'segment_dnn',
  'segment_dnn_mosaic',
  'segment_old',
  'segment_old_mosaic',
  'mosaic',
];

export const IMAGES_DATASETS_BUCKET = 'images-datasets';
export const SEGMENTED_DATASETS_BUCKET = 'segmented-datasets';
export const CLASSIFIED_DATASETS_BUCKET = 'classified-datasets';
export const DELIVERY_REPORTS_BUCKET = 'delivery-reports';
export const MOSAICS_DATASETS_BUCKET = 'mosaics-datasets';
export const SEGMENTED_MOSAICS_BUCKET = 'segmented-mosaics';
export const ANNOTATED_MOSAICS_BUCKET = 'annotated-mosaics';

export const BUCKETS = [
  IMAGES_DATASETS_BUCKET,
  SEGMENTED_DATASETS_BUCKET,
  CLASSIFIED_DATASETS_BUCKET,
  DELIVERY_REPORTS_BUCKET,
  MOSAICS_DATASETS_BUCKET,
  SEGMENTED_MOSAICS_BUCKET,
  ANNOTATED_MOSAICS_BUCKET,
];
export const REFERENCE_DATABASE_VALUES = [
  'v4',
  'v5',
  'v6',
  'v10',
  'v10_flt',
  'v10_OPADE',
  'v3.7.3_D6322',
  'v7.1.1_D6300',
  'v7.1.1_D6331',
];

export const COMMANDS = [
  { id: 'mergeWells', label: 'Merge wells' },
  { id: 'mergeSlides', label: 'Merge slides' },
  { id: 'deliveryReport', label: 'Delivery report' },
];

export const JOB_NAMES = [
  'all',
  'annotated_mosaic',
  'classification',
  'classification_crt',
  'delivery_report',
  'mosaic',
  'multiple_wells_summary',
  'segmentation',
  'segmentation_dnn',
  'segmented_mosaic',
];

export const JOB_STATES = [
  'all',
  'submitted',
  'pending',
  'runnable',
  'starting',
  'running',
  'succeeded',
  'failed',
];

export const DAYS_FILTER = ['Last Day', 'Last 3 Days', 'Last 7 Days'];

export const REQUEST_TYPE = {
  POST: 'post',
  GET: 'get',
  PUT: 'put',
  DELETE: 'delete',
};

export const SOCKET_USER_UPDATE_EVENT = () =>
  `user_update_${getIdFromLocalStorage()}`;

export const LAUNCH_BUTTON = 'LAUNCH';
export const PREVIEW_BUTTON = 'PREVIEW';
